import auth from "./auth/index";
import business from "./business";
import wallet from './wallet'

import { combineReducers } from "redux";

export default combineReducers({ auth,  business, wallet });   
